import API, { APIResponse } from '../commons/api'

export interface SprintProductItemProp {
  deliverableUuid: string
  deliverableLockVersion: number
  sprintUuid: string
  estimatedHour?: number
  displayOrder?: number
  // Sprint×PBI単位のPBI担当者
  assigneeUuid?: string | null
  // Sprint×PBI単位のスプリントゴール
  sprintGoal?: string | null
}

export interface UpdateSprintProductItemProps {
  added: SprintProductItemProp[]
  edited: SprintProductItemProp[]
  deleted: SprintProductItemProp[]
}

export async function updateSprintProductItems(
  props: UpdateSprintProductItemProps
): Promise<APIResponse> {
  return API.functional.request(
    'POST',
    '/api/v1/projects/scrums/sprint_product_items/batch',
    props
  )
}
